const PropTypes = require('prop-types');
// @vendors
const React = require('react');

// @commons
const Wizard = require('components/commons/wizard/wizard');

// @components
const BrokerCreateTransferOfDerivativesStep1 = require('./brokerCreateTransferOfDerivativesStep1/brokerCreateTransferOfDerivativesStep1');
const BrokerCreateTransferOfDerivativesStep2 = require('./brokerCreateTransferOfDerivativesStep2/brokerCreateTransferOfDerivativesStep2');

const BrokerCreateTransferOfDerivativesWizard = props => {
    const {
        immAccounts,
        immBrokerCreateTransferOfDerivatives,
        immBrokerWallets,
        actions,
        onChangeOriginDerivative,
        onChangeAmount,
        onChangeAccount
    } = props;

    const immSteps = immBrokerCreateTransferOfDerivatives.get('steps');
    const visibleStep = immBrokerCreateTransferOfDerivatives.get('visibleStep');
    const accountsMap = immAccounts.get('byId');

    return (
        <Wizard
            wizardClass="broker-convenience-mifid-test-wizard"
            actions={actions}
            immSteps={immSteps}
            stepsAmount={immSteps.size}
            visibleStep={visibleStep}
        >
            <BrokerCreateTransferOfDerivativesStep1
                immAccounts={immAccounts}
                immBrokerCreateTransferOfDerivatives={immBrokerCreateTransferOfDerivatives}
                immBrokerWallets={immBrokerWallets}
                actions={actions}
                onChangeOriginDerivative={onChangeOriginDerivative}
                onChangeAmount={onChangeAmount}
                onChangeAccount={onChangeAccount}
            />
            <BrokerCreateTransferOfDerivativesStep2
                immAccounts={accountsMap}
                immBrokerCreateTransferOfDerivatives={immBrokerCreateTransferOfDerivatives}
                immBrokerWallets={immBrokerWallets}
                actions={actions}
            />
        </Wizard>
    );
};

BrokerCreateTransferOfDerivativesWizard.propTypes = {
    immAccounts: PropTypes.object.isRequired,
    immBrokerCreateTransferOfDerivatives: PropTypes.object.isRequired,
    immBrokerWallets: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
    onChangeOriginDerivative: PropTypes.func.isRequired,
    onChangeAmount: PropTypes.func.isRequired,
    onChangeAccount: PropTypes.func.isRequired
};

module.exports = BrokerCreateTransferOfDerivativesWizard;